import { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/Icon';

import { LINKS } from './constants';
import HeaderSubMenuLink from './HeaderSubMenuLink';

class HeaderSubMenu extends Component {
  state = { isSubmenuOpened: false, preventSubmenuOpen: false };

  closeSubmenu = (preventOpen = false) => {
    if (!this.state.isSubmenuOpened) return;

    const nextState = {
      ...this.state,
      ...{ isSubmenuOpened: false },
      ...(preventOpen && { preventSubmenuOpen: true }),
    };

    this.setState(nextState, () => {
      clearTimeout(this.timeout);
      if (!preventOpen) return;

      this.timeout = setTimeout(
        () => this.setState({ preventSubmenuOpen: false }),
        150
      );
    });
  };

  openSubmenu = (preventOpen = false) => {
    const { preventSubmenuOpen, isSubmenuOpened } = this.state;

    !preventSubmenuOpen &&
      !isSubmenuOpened &&
      this.setState({
        isSubmenuOpened: true,
        ...(preventOpen && { preventSubmenuOpen: true }),
      });
  };

  forceOpenSubmenu = () => {
    this.setState({ preventSubmenuOpen: false, isSubmenuOpened: true });
  };

  handleLinkClick = () => {
    const { isBurgerOpened, closeBurger } = this.props;

    isBurgerOpened && closeBurger();
  };

  handleSubmenuClick = () => {
    this.state.isSubmenuOpened ? this.closeSubmenu() : this.openSubmenu();
  };

  handleMouseEnter = () => {
    !this.props.isBurger && !this.props.isMobile && this.openSubmenu();
  };

  handleMouseOver = () => {
    !this.props.isBurger && !this.props.isMobile && this.forceOpenSubmenu();
  };

  handleMouseLeave = () => {
    !this.props.isBurger && this.closeSubmenu();
  };

  handleMouseEnterBody = e => {
    e.stopPropagation();
    !this.props.isBurger && !this.props.isMobile && this.openSubmenu(true);
  };

  handleMouseLeaveBody = e => {
    e.stopPropagation();
    !this.props.isBurger && this.closeSubmenu(true);
  };

  handleMouseOverBody = e => {
    e.stopPropagation();
  };

  render() {
    const { isMobile, isBurger } = this.props;
    const { isSubmenuOpened, preventSubmenuOpen } = this.state;
    return (
      <div
        className={cx('header__nav-item', {
          'header__nav-item_opened': isSubmenuOpened && isBurger,
          'header__nav-item_hovered':
            !preventSubmenuOpen && isSubmenuOpened && !isBurger,
        })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseOver={this.handleMouseOver}
        onClick={this.handleSubmenuClick}
      >
        {isMobile || isBurger ? (
          <Fragment>
            <Icon className="header__nav-item-icon" icon="arrow-opening" />
            <div className="header__nav-link">Platform</div>
          </Fragment>
        ) : (
          <Link to="/website-builder" className="header__nav-link">
            Platform
          </Link>
        )}
        <ul
          className="submenu"
          onMouseEnter={this.handleMouseEnterBody}
          onMouseLeave={this.handleMouseLeaveBody}
          onMouseOver={this.handleMouseOverBody}
        >
          {LINKS.map((link, index) => (
            <HeaderSubMenuLink
              {...link}
              key={index}
              first={index === 0}
              last={index === LINKS.length - 1}
              onClick={this.handleLinkClick}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default HeaderSubMenu;
